import { Link } from 'react-router-dom'

const SmartLink = ({ isNextUrl, href, children, className = '', ...props }) => {
  if (isNextUrl) {
    return (
      <a
        href={`${window.location.origin}${href}`}
        className={`no-underline ${className}`}
        {...props}>
        {children}
      </a>
    )
  }
  return (
    <Link to={href} className={`no-underline ${className}`} {...props}>
      {children}
    </Link>
  )
}

export default SmartLink
